import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from '../../hooks/useAuth'
import { loginPathWithReturn } from '../../lib/authRedirect'
import { SetAsideGrantSync } from '../canvasser/SetAsideGrantSync'

/**
 * Layout-route guard: renders child routes only when a user is authenticated.
 * Otherwise redirects to /login, preserving the attempted destination as
 * `returnTo` so the user lands back where they were headed after signing in.
 *
 * This is the first line of defence (blocks direct navigation to a protected
 * URL with no session). The axios 401 interceptor is the second line, catching
 * an expired cookie mid-session that this localStorage check cannot see.
 */
export function RequireAuth() {
  const { isAuthenticated } = useAuth()
  const location = useLocation()

  if (!isAuthenticated) {
    return <Navigate to={loginPathWithReturn(location.pathname + location.search)} replace />
  }

  return (
    <>
      <SetAsideGrantSync />
      <Outlet />
    </>
  )
}
